export interface PhotoUrls {
    photoId: string;
    thumbnail?: string;
    list?: string;
    medium?: string;
    gallery?: string;
    large?: string;
    fullSize?: string;
    plusSize?: string;
}
